// DO NOT EDIT -- generated from fs/services/ingestion-settings/elementrulestore.proto

import * as llm_tool from '../llm-tool';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';

/** Accessed from FSTA */
export namespace ElementRetainRuleStorePublic {

  export const GetElementRetainRulesEndpoint = "/grpc/ingestion_settings.ElementRetainRuleStorePublic/GetElementRetainRules";
  export function GetElementRetainRules(sender: (req: GetElementRetainRulesReq, endpoint: string) => Promise<GetElementRetainRulesRsp>, req: GetElementRetainRulesReq): { promise: () => Promise<GetElementRetainRulesRsp>, endpoint: string } {
    return {
      promise: () => sender(req, GetElementRetainRulesEndpoint),
      endpoint: GetElementRetainRulesEndpoint
    };
  }

  export const SetElementRetainRuleEndpoint = "/grpc/ingestion_settings.ElementRetainRuleStorePublic/SetElementRetainRule";
  export function SetElementRetainRule(sender: (req: SetElementRetainRuleReq, endpoint: string) => Promise<ElementRetainRuleRecord>, req: SetElementRetainRuleReq): { promise: () => Promise<ElementRetainRuleRecord>, endpoint: string } {
    return {
      promise: () => sender(req, SetElementRetainRuleEndpoint),
      endpoint: SetElementRetainRuleEndpoint
    };
  }

  export const ArchiveElementRetainRuleEndpoint = "/grpc/ingestion_settings.ElementRetainRuleStorePublic/ArchiveElementRetainRule";
  export function ArchiveElementRetainRule(sender: (req: ArchiveElementRetainRuleReq, endpoint: string) => Promise<ElementRetainRuleRecord>, req: ArchiveElementRetainRuleReq): { promise: () => Promise<ElementRetainRuleRecord>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveElementRetainRuleEndpoint),
      endpoint: ArchiveElementRetainRuleEndpoint
    };
  }

  export const UnarchiveElementRetainRuleEndpoint = "/grpc/ingestion_settings.ElementRetainRuleStorePublic/UnarchiveElementRetainRule";
  export function UnarchiveElementRetainRule(sender: (req: UnarchiveElementRetainRuleReq, endpoint: string) => Promise<ElementRetainRuleRecord>, req: UnarchiveElementRetainRuleReq): { promise: () => Promise<ElementRetainRuleRecord>, endpoint: string } {
    return {
      promise: () => sender(req, UnarchiveElementRetainRuleEndpoint),
      endpoint: UnarchiveElementRetainRuleEndpoint
    };
  }
}

/** Accessed from the cook/index pipelines */
export namespace ElementRetainRuleStore {

  export const GetElementRetainRulesEndpoint = "/grpc/ingestion_settings.ElementRetainRuleStore/GetElementRetainRules";
  export function GetElementRetainRules(sender: (req: GetElementRetainRulesReq, endpoint: string) => Promise<GetElementRetainRulesRsp>, req: GetElementRetainRulesReq): { promise: () => Promise<GetElementRetainRulesRsp>, endpoint: string } {
    return {
      promise: () => sender(req, GetElementRetainRulesEndpoint),
      endpoint: GetElementRetainRulesEndpoint
    };
  }

  export const SetElementRetainRuleEndpoint = "/grpc/ingestion_settings.ElementRetainRuleStore/SetElementRetainRule";
  export function SetElementRetainRule(sender: (req: SetElementRetainRuleReq, endpoint: string) => Promise<ElementRetainRuleRecord>, req: SetElementRetainRuleReq): { promise: () => Promise<ElementRetainRuleRecord>, endpoint: string } {
    return {
      promise: () => sender(req, SetElementRetainRuleEndpoint),
      endpoint: SetElementRetainRuleEndpoint
    };
  }
}

/**
 * Represents a single rule that is currently used for Element ID
 * and selector canonicalization rules in the cook/indexing pipelines.
 * In the cook, only presence of a configured attribute (and not its rules)
 * are inspected. If there is a match, the attribute and its value are kept
 * for further downstream processing. In the indexing pipeline, we check presence
 * and the rules when applying canonicalization and Element ID heuristics.
 * If a CSS selector (representing an HTML element) has a particular
 * element_attr_key which could be class, id or any other kind of attribute,
 * we will apply the block_list rules first, then the allow_list rules, and then all other
 * canonicalization heuristics.
 */
export interface ElementRetainRule {
  /** Datastore unique-id. */
  id: protobuf.int64;
  elementAttrKey: string;
  /**
   * A allow_list rule is a pattern used to match against the value component
   * of the above element_attribute_key. If the value component of the key
   * matches a allow_list rule, we will keep that value full-stop.
   */
  allowList: string[];
  /**
   * A block_list rule is a pattern used to match against the value component
   * of the above element_attribute_key. If the value component of the key
   * matches a block_list rule, we will drop that value full-stop.
   */
  blockList: string[];
  suggestion: llm_tool.AttributeSuggestion | null;
}

export interface ElementRetainRuleRecord {
  rule: ElementRetainRule | null;
  metadata: protoauditstore.AuditMetadata | null;
}

export interface GetElementRetainRulesReq {
  orgId: string;
  includeArchived: boolean;
}

export interface GetElementRetainRulesRsp {
  rules: ElementRetainRuleRecord[];
}

export interface SetElementRetainRuleReq {
  orgId: string;
  rule: ElementRetainRule | null;
}

export interface ArchiveElementRetainRuleReq {
  orgId: string;
  rule: ElementRetainRule | null;
}

export interface UnarchiveElementRetainRuleReq {
  orgId: string;
  rule: ElementRetainRule | null;
}
